import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Mail, Lock, Eye, EyeOff, User, Phone, Heart } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import '../../../assets/css/donor/auth/DonorAuth.css';

const DonorRegister = () => {

  const navigate = useNavigate();
  const { baseUrl, regExpChecker } = useContext(AppContext);
  const [fullName, setFullName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [agreeToTerms, setAgreeToTerms] = useState();

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [fullNameError, setFullNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [registerError, setRegisterError] = useState('');

  useEffect(() => {

    const donorEmail = localStorage.getItem('donorEmail');
    const donorPassword = localStorage.getItem('donorPassword');

    if (donorEmail && donorPassword) {
      setIsLoading(true);
      navigate('/donor/dashboard');
    }

  }, []);

  const handleRegister = (e) => {

    e.preventDefault();
    setIsLoading(true);

    const formdata = new FormData();

    formdata.append('fullname', fullName);
    formdata.append('email', email);
    formdata.append('phone', phone);
    formdata.append('password', password);


    axios.post(`${baseUrl}/donor/auth/donorsignup`, formdata)

      .then((response) => {

        if (response.data.error) {

          setRegisterError(response.data.error);
          setIsLoading(false);

        } else if (response.data.success === true) {

          localStorage.setItem('donorEmail', response.data.donor.email);
          localStorage.setItem('donorPassword', response.data.donor.password);

          navigate('/donor/dashboard');

        } else {
      setRegisterError(response.data.message || 'Something went wrong!');
          setIsLoading(false);

        }

      })

      .catch((error) => {

        setRegisterError(error.response?.data?.message || 'Something went wrong!');
        setIsLoading(false);

      });

  };

  return (
    <div className="donor-auth-container">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100 py-5">
          <Col lg={10} xl={9}>
            <Card className="donor-auth-card">
              <Row className="g-0">

                <Col md={6} className="donor-auth-left">
                  <div className="donor-auth-branding">
                    <div className="donor-auth-logo"><Heart size={48} /></div>
                    <h2>Join Our Community</h2>
                    <p>Start making a difference today</p>
                  </div>
                </Col>

                <Col md={6} className="donor-auth-right">
                  <div className="donor-auth-form-wrapper">

                    {registerError && <Alert variant="danger">{registerError}</Alert>}

                    <Form>

                      <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <div className="donor-auth-input-wrapper">
                          <User size={20} />
                          <Form.Control
                            type="text"
                            placeholder="Full Name"
                            value={fullName}
                            onChange={(event) => {
                              setFullName(event.target.value);
                              setFullNameError(regExpChecker("username", event.target.value));
                            }}
                          />
                          <p style={{ color: "red" }}>{fullNameError}</p>
                        </div>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <div className="donor-auth-input-wrapper">
                          <Mail size={20} />
                          <Form.Control
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(event) => {
                              setEmail(event.target.value);
                              setEmailError(regExpChecker("email", event.target.value));
                            }}
                          />
                          <p style={{ color: "red" }}>{emailError}</p>
                        </div>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Phone</Form.Label>
                        <div className="donor-auth-input-wrapper">
                          <Phone size={20} />
                          <Form.Control
                            type="tel"
                            placeholder="+92 300 1234567"
                            value={phone}
                            onChange={(e) => {
                              setPhone(e.target.value);
                              setPhoneError(regExpChecker("phone", e.target.value));
                            }}
                          />
                          <p style={{ color: "red" }}>{phoneError}</p>
                        </div>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <div className="donor-auth-input-wrapper">
                          <Lock size={20} />
                          <Form.Control
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            value={password}
                            onChange={(event) => {
                              setPassword(event.target.value)
                              setPasswordError(regExpChecker("password", event.target.value));
                            }}
                          />
                          <p style={{ color: "red" }}>{passwordError}</p>
                          <button type="button" onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                          </button>
                        </div>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Confirm Password</Form.Label>
                        <div className="donor-auth-input-wrapper">
                          <Lock size={20} />
                          <Form.Control
                            type={showConfirmPassword ? 'text' : 'password'}
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            setConfirmPasswordError(regExpChecker("confirmPassword", e.target.value ,password));
                          }}
                          />
                            <p style={{ color: "red" }}>{confirmPasswordError}</p>
                          <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                            {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                          </button>
                        </div>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Check
                          type="checkbox"
                          checked={agreeToTerms}
                          onChange={(e) => setAgreeToTerms(e.target.checked)}
                          label="I agree to Terms & Conditions"
                        />
                      </Form.Group>

                      <Button
                        type="button"
                        className="w-100"
                        disabled={isLoading}
                        onClick={handleRegister}
                      >
                        {isLoading ? <Spinner animation="border" size="sm" /> : 'Create Account'}
                      </Button>

                      <p className="mt-3 text-center">
                        Already have an account? <Link to="/donor/login">Login</Link>
                      </p>

                    </Form>
                  </div>
                </Col>

              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DonorRegister;